import { createAction, props } from '@ngrx/store';
import { User } from 'src/app/shared/models/user/User';

export const LoginTypes = {
  LOGIN: '[Login Page] Login',
  LOGIN_ERROR: '[Login Page] Login error',
  LOGIN_SUCCESS: '[Login Page] Login success'
};

export const LogoutTypes = {
  LOGOUT: '[Dashboard Page] Logout',
  LOGOUT_SUCCESS: '[Dashboard Page] Logout success'
};
export const UserActionTypes = {
  GET_CURRENT_USER: '[USER] Get current user',
  GET_CURRENT_USER_SUCCESS: '[USER] Get current user success'
};
export const LoginAction = createAction(
  LoginTypes.LOGIN,
  props<{ username: string; password: string; keepSignedIn: boolean }>()
);

export const LoginSuccessAction = createAction(
  LoginTypes.LOGIN_SUCCESS,
  props<{ authenticated: boolean; user: User }>()
);

export const LoginErrorAction = createAction(LoginTypes.LOGIN_ERROR, props<{}>());

export const LogoutAction = createAction(LogoutTypes.LOGOUT);

export const LogoutSuccessAction = createAction(LogoutTypes.LOGOUT_SUCCESS);

export const GetCurrentUserAction = createAction(UserActionTypes.GET_CURRENT_USER);

export const GetCurrentUserSuccessAction = createAction(
  UserActionTypes.GET_CURRENT_USER_SUCCESS,
  props<{ user: User }>()
);
